<script setup lang="ts">
const isDev = import.meta.env.DEV
</script>

<template>
  <Teleport v-if="isDev" to="[data-teleport-dev-only]" defer>
    <UPopover>
      <UButton label="Dev Tools" icon="i-lucide-code" variant="soft" color="neutral" size="xs" />

      <template #content>
        <div class="flex flex-col gap-2 p-3">
          <slot />
        </div>
      </template>
    </UPopover>
  </Teleport>
</template>
